import React from "react";
import { Card } from "./ui";
import { Activity } from "lucide-react";
import { HealthBadge, HealthSignals } from "./EntityHealth";
import FocusChip from "./FocusChip";
import { useApp } from "../context/AppContext";

const HEALTH_ORDER = { at_risk: 0, needs_attention: 1, healthy: 2 };

// Entity health strip on Group HQ — one tile per entity, riskiest first.
export default function HealthStrip({ entities, entityHealth, t, navigate }) {
  const { focusSummary } = useApp();
  const items = entities
    .map((e) => ({ e, h: entityHealth[e.id] }))
    .filter((x) => x.h)
    .sort((a, b) => (HEALTH_ORDER[a.h.status] ?? 3) - (HEALTH_ORDER[b.h.status] ?? 3));
  if (!items.length) return null;
  return (
    <Card className="mb-6" data-testid="health-strip">
      <div className="flex items-center gap-2 mb-1">
        <Activity className="w-4 h-4 text-text-secondary" />
        <h3 className="font-heading font-medium">{t("entity_health")}</h3>
      </div>
      <p className="text-text-secondary text-sm mb-5">{t("entity_health_subtitle")}</p>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-3">
        {items.map(({ e, h }) => (
          <div key={e.id} className="rounded-xl border p-3 flex flex-col gap-2.5" data-testid={`health-strip-${e.key}`}>
            <button onClick={() => navigate(`/entity/${e.key}`)} data-testid={`health-strip-entity-${e.key}`}
              className="flex items-center gap-2 text-left group">
              <span className="w-2 h-2 rounded-full shrink-0" style={{ backgroundColor: e.color }} />
              <span className="text-sm font-medium truncate flex-1 group-hover:underline">{e.name}</span>
              <HealthBadge status={h.status} />
            </button>
            {h.signals?.length > 0 ? (
              <HealthSignals signals={h.signals} entityKey={e.key} />
            ) : (
              <span className="text-[11px] text-text-secondary">{t("health_all_clear")}</span>
            )}
            <FocusChip focus={focusSummary?.[e.id]} />
          </div>
        ))}
      </div>
    </Card>
  );
}
